import * as runtypes from 'runtypes';

export const parse = (data: string): Record<string, unknown> | null => {
  try {
    return runtypes.Dictionary(runtypes.Unknown, runtypes.String).check(JSON.parse(data));
  } catch (_) {
    return null;
  }
};
